import React from "react";

import { Dropdown } from "@packages/ds";

import { sendPendoEventDropdownItem } from "Store/analytics/pendoFunctions";

interface ConsoleLinkItemProps
  extends React.ComponentProps<typeof Dropdown.LinkItem> {
  analyticId?: string;
}

const LinkItem = React.forwardRef<HTMLDivElement, ConsoleLinkItemProps>(
  function LinkItem(
    {
      children,
      href,
      to,
      analyticId,
      onSelect,
      ...props
    }: ConsoleLinkItemProps,
    ref
  ) {
    const toProp = typeof to === "string" ? to : to?.pathname;

    const onSelectHandler = e => {
      sendPendoEventDropdownItem({
        analyticId: analyticId || href || toProp,
        type: "link"
      });

      onSelect?.(e);
    };

    return (
      <Dropdown.LinkItem
        href={href}
        to={to}
        onSelect={onSelectHandler}
        ref={ref}
        {...props}
      >
        {children}
      </Dropdown.LinkItem>
    );
  }
);

export default LinkItem;
